import {
  Box,
  Button,
  Switch,
  Typography
} from "@dealer-center/core-components";
import { useEffect } from "react";
import type { ExperimentsWithEnabled } from "@dealer-center/core-pages-experiment-enablement-interface";

export interface CorePagesExperimentEnablementProps<
  TExperiment extends ExperimentsWithEnabled<string>
> {
  experiments: readonly TExperiment[];
  onToggleExperiment: (experiment: string) => void;
}

export const CorePagesExperimentEnablement = <
  TExperiment extends ExperimentsWithEnabled<string>
>({
  experiments,
  onToggleExperiment
}: CorePagesExperimentEnablementProps<TExperiment>) => {
  useEffect(() => {
    document.title = "Experiment Enablement";
  }, []);
  return (
    <>
      <Typography variant="h1">Experiment Enablement</Typography>
      <Typography variant="label-md">
        This page allows you to enable or disable experiments.
      </Typography>
      <Box
        sx={{ display: "flex", flexDirection: "row", gap: "1em", mt: "1em" }}
      >
        <Button
          analyticsConfiguration={{
            eventName: "experiment-enablement-all-off"
          }}
          onClick={() =>
            experiments.forEach(experiment => {
              if (!experiment.enabled) {
                onToggleExperiment(experiment.id);
              }
            })
          }
        >
          All On
        </Button>
        <Button
          analyticsConfiguration={{
            eventName: "experiment-enablement-all-on"
          }}
          onClick={() =>
            experiments.forEach(experiment => {
              if (experiment.enabled) {
                onToggleExperiment(experiment.id);
              }
            })
          }
        >
          All Off
        </Button>
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: "1em", mt: "1em" }}
      >
        {experiments.map(experiment => (
          <Box
            key={experiment.id}
            sx={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Switch
              id={experiment.id}
              checked={experiment.enabled}
              label={experiment.name}
              layout="vertical"
              onClick={() => onToggleExperiment(experiment.id)}
            />
            <Typography variant="label-md">{experiment.description}</Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};
